import React, { useEffect, useState } from "react";
import Roulette from "../components/Roulette";
import Title from "../components/Title";
import Subtitle from "../components/Subtitle";
import Tip from "../components/Tip";
import Bang from "../components/Bang";

import Fail from "../assets/images/items/fail.png";
import Discount from "../assets/images/items/discount.png";
import Free from "../assets/images/items/free.png";

import decor1 from "../assets/images/decors/decor1.png";
import decor2 from "../assets/images/decors/decor2.png";
import decor3 from "../assets/images/decors/decor3.png";
import decor4 from "../assets/images/decors/decor4.png";
import decor5 from "../assets/images/decors/decor5.png";

const RouletteScreen = ({ setWinnerType, setIsChangeble, isChangeble }) => {
  const [showRoulette, setShowRoulette] = useState(false);
  const [rouletteItemsList, setRouletteItemsList] = useState([]);

  const [access, setAccess] = useState(false);
  const [accessError, setAccessError] = useState(null);

  const baseRouletteItems = [
    { img: Fail, alt: "Завтра повезёт" },
    { img: Discount, alt: "Скидка 50% на отрисовку" },
    { img: Free, alt: "Бесплатная отрисовка" },
  ];

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  const generateItemsList = (frequencies) => {
    const generatedItems = [];

    for (let i = 0; i < 100; i++) {
      const rand = Math.random();

      if (rand < frequencies.fail) {
        generatedItems.push(baseRouletteItems[0]);
      } else if (rand < frequencies.fail + frequencies.discount) {
        generatedItems.push(baseRouletteItems[1]);
      } else {
        generatedItems.push(baseRouletteItems[2]);
      }
    }

    shuffleArray(generatedItems);
    setRouletteItemsList(generatedItems);
  };

  useEffect(() => {
    let jwtToken = window.sessionStorage.getItem("jwtToken");

    const login = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const paramValue = searchParams.get("botUid");
      const tg = window.Telegram.WebApp;
      const initData = tg.initData;
      try {
        const res = await fetch("https://roulette.sp-hub.org/api/auth/tg", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            botUID: paramValue,
            initData: initData,
          }),
        });
        const data = await res.json();
        console.log(data);

        window.sessionStorage.setItem("jwtToken", data.access_token);

        await fetchData();
        await fetchAccess();
      } catch (error) {
        console.log(error);
      }
    };

    async function fetchData() {
      const jwtToken = window.sessionStorage.getItem("jwtToken");
      try {
        const res = await fetch("https://roulette.sp-hub.org/api/roulette/probabilities", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${jwtToken}`,
          },
        });
        const data = await res.json();

        if (data) {
          generateItemsList(data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function fetchAccess() {
      const jwtToken = window.sessionStorage.getItem("jwtToken");
      try {
        const res = await fetch("https://roulette.sp-hub.org/api/roulette/access", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${jwtToken}`,
          },
        });
        const data = await res.json();
        console.log("Access data:", data);

        if (data.access) {
          setAccess(true);
          setShowRoulette(true);
        } else if (data.message === "Invalid or expired token") {
          console.log("Removing token");
          window.sessionStorage.removeItem("jwtToken");
          window.location.reload();
        } else if (data.access === false) {
          await getIsChangeble();

          if (!isChangeble) {
            if (data.message === "Invalid or expired token") {
              console.log("Removing token");
              window.sessionStorage.removeItem("jwtToken");
              window.location.reload();
            } else {
              setAccessError(data.message);
              setShowRoulette(true);
              console.log('show true')
            }
          }
        }
      } catch (error) {
        console.log(error);
        window.sessionStorage.removeItem("jwtToken");
        window.location.reload();
      }
    }

    const getIsChangeble = async () => {
      const jwtToken = window.sessionStorage.getItem("jwtToken");
      try {
        const response = await fetch("https://roulette.sp-hub.org/api/exchange/access", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${jwtToken}`,
          },
        });
        const data = await response.json();
        setIsChangeble(data);

        if (data?.result === false) {
          setShowRoulette(true);
        }

        console.log("isChangeble", data);
      } catch (error) {
        console.error(error);
      }
    };
    if (!jwtToken || jwtToken === "undefined") {
      login();
    } else {
      fetchData();
      fetchAccess();
    }
  }, []);

  return (
    <>
      {showRoulette ? (
        <main className="relative z-10 bg-main flex items-center justify-center bg-cover bg-center min-h-screen w-full overflow-hidden">
          <div className="absolute z-[-1] -left-24 top-16 animate-moveX animate-moveY">
            <div className="absolute h-44 w-44 bg-blue opacity-10 blur-3xl rounded-full z-[-1] animate-pulse"></div>
            <img src={decor1} alt="Процент" />
          </div>
          <div className="absolute -z-10 -right-16 -bottom-8 animate-moveX animate-moveY">
            <div className="absolute h-44 w-44 right-1 bg-green opacity-5 blur-3xl rounded-full z-[-1] animate-pulse"></div>
            <img src={decor3} alt="Процент" />
          </div>
          <div className="absolute -z-10 left-24 top-112 animate-moveX animate-moveY">
            <img src={decor2} alt="Процент" />
          </div>
          <div className="absolute -z-10 -left-48 -bottom-20 animate-moveX animate-moveY">
            <img src={decor4} alt="Процент" />
          </div>
          <div className="absolute -z-10 -right-80 top-4 animate-moveX animate-moveY">
            <img src={decor5} alt="Процент" />
          </div>
          <div className="container mx-[5px] flex justify-center rounded-lg bg-gradient-dark-green border-darkGreen border-4">
            <section className="roulette frame">
              <div className="mobile:mb-6 desktop:mb-16">
                <Bang />
              </div>
              <div className="flex justify-center mobile:mb-3 desktop:mb-4">
                <Title text="Ежедневная рулетка" />
              </div>

              {accessError ? (
                <div 
                className="flex justify-center mobile:mb-6 desktop:mb-12"
                dangerouslySetInnerHTML={{ __html: accessError }}
                />
              ) : (
                <>
                  <div className="flex justify-center mobile:mb-6 desktop:mb-12">
                    <Subtitle text="Крути рулетку каждый день и получай шанс на бесплатную <br/> отрисовку или скидку. <b>Испытай удачу прямо сейчас!</b>" />
                  </div>
                  <Roulette
                    setWinnerType={setWinnerType}
                    setIsChangeble={setIsChangeble}
                    isChangeble={isChangeble}
                    setShowRoulette={setShowRoulette}
                    access={access}
                    rouletteItemsList={rouletteItemsList}
                  />
                  <div className="flex justify-center mobile:mb-12 desktop:mb-24">
                    <Tip text="*Крутить можно раз в 24 часа" />
                  </div>
                </>
              )}
            </section>
          </div>
        </main>
      ) : (
        <div role="status" className="h-screen flex items-center justify-center">
          <svg
            aria-hidden="true"
            className="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
            viewBox="0 0 100 101"
            fill="#0b1a1d"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      )}
    </>
  );

};

export default RouletteScreen;
